import * as types from "../ActionType";
import axios from "axios";
import { notifyError , notifysuccess } from "../../components/general/Notification";
import { hasExpirition } from "../../components/general/general-component/abstruct-component/useExpirition";
import { baseApi } from "../../api/Instances";
const END_POINT = process.env.REACT_APP_BASE_URL;

const get = (arr,type) => {
    return ({
        type: type,
        payload: arr
    })
}

export const loadSettings = () => {
    return async function (dispatch) {
        try {
            const response = await baseApi.get("/api/configurations");
            if (response.data.status === "Success") {
                dispatch(get(response.data.data,types.GET_SETTING))
            }
        } catch (error) {
            notifyError(error.response?.data?.message || "Error occurred");
        }
    };
};


export const putUpdateSetting = (settingName,value,setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        console.log('value',value)
        axios.put(`${END_POINT}/api/configurations/${settingName}`, {value}, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(loadSettings());
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
            notifyError(err.response.data.message)
        })
    }
}

